const Header = () => (
  <header>
    <h3>Tasks</h3>
  </header>
);

export default Header;
